// extracted by css-extract-rspack-plugin
export default {"animate":"_50327e3b","shimmerLoadingBackground":"_3b5bb90d","title":"_374f5980","item":"_a5bf235"};